module.exports = __webpack_public_path__ + "img/id.ff2a0ac0.png";